"use strict";

exports.__esModule = true;
exports.default = void 0;

var _card = _interopRequireDefault(require("./card"));

var _cardHeader = _interopRequireDefault(require("./card-header"));

var _cardBody = _interopRequireDefault(require("./card-body"));

var _cardTitle = _interopRequireDefault(require("./card-title"));

var _cardSubTitle = _interopRequireDefault(require("./card-sub-title"));

var _cardFooter = _interopRequireDefault(require("./card-footer"));

var _cardImg = _interopRequireDefault(require("./card-img"));

var _cardImgLazy = _interopRequireDefault(require("./card-img-lazy"));

var _cardText = _interopRequireDefault(require("./card-text"));

var _cardGroup = _interopRequireDefault(require("./card-group"));

var _plugins = require("../../utils/plugins");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var components = {
  BCard: _card.default,
  BCardHeader: _cardHeader.default,
  BCardBody: _cardBody.default,
  BCardTitle: _cardTitle.default,
  BCardSubTitle: _cardSubTitle.default,
  BCardFooter: _cardFooter.default,
  BCardImg: _cardImg.default,
  BCardImgLazy: _cardImgLazy.default,
  BCardText: _cardText.default,
  BCardGroup: _cardGroup.default
};
var _default = {
  install: (0, _plugins.installFactory)({
    components: components
  })
};
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/es/components/card/index.js
// module id = awSw
// module chunks = 0